import { palette, ColorScale, definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import { breadcrumbTheme, datatableTheme, drawerTheme, stepsTheme } from "./designtokens/components";

const primaryColor = palette("#337ab7") as ColorScale;
 
const myPreset = definePreset(Aura, {
  semantic: {
    primary: primaryColor,
  },
  components: {
    datatable: datatableTheme,
    breadcrumb: breadcrumbTheme,
    drawer: drawerTheme,
    steps: stepsTheme,
  },
});
 
export const pcpPrimeNgConfig = {
  theme: {
    preset: myPreset,
    options: {
      darkModeSelector: ".my-app-dark",
      cssLayer: {
        name: "primeng",
        order: "bootstrap, primeng",
      },
    },
  },
};